module.exports = __webpack_public_path__ + "img/signin-header.8239fee1.png";